import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import { Modal } from '@cian/ui-kit';

interface IManifestModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ManifestModal: React.FC<IManifestModalProps> = ({ open, onOpenChange }) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      header={<div className={styles['title']}>Циан Посуточно</div>}
      width="80%"
      body={
        <div className={styles['container']}>
          <div className={styles['body-title']}>
            Бизнес посуточной аренды успешен, когда всё организовано и{NBSP}ваши объекты загружены.
          </div>
          <div className={styles['scroll-textblock']}>
            <div className={styles['text']}>
              <div>
                <div>
                  Вы вкладываете время, силы и ресурсы — и вправе рассчитывать на стабильный доход. Но на практике рынок
                  непостоянен: сезонность, конкуренция, нестабильный спрос.
                </div>
                <div>
                  В одиночку удержать все элементы бизнеса под контролем сложно. Ключ к стабильности — партнёр, на
                  которого можно положиться.
                </div>
              </div>
              <div>
                <div>
                  <b>Циан Посуточно — площадка, где ваши усилия превращаются в{NBSP}стабильный доход.</b> Мы привлекаем
                  гостей, которые ценят порядок, бережно относятся к жилью и готовы платить за комфорт. Это аудитория
                  большой экосистемы Циан — люди, которые покупают, сдают, и продают недвижимость, для них она — не
                  {NBSP}пустой звук, и к арендованному жилью они относятся, как к{NBSP}своему.
                </div>
                <div>
                  Мы обеспечиваем прозрачные условия и заботливую поддержку — чтобы вы могли сосредоточиться на главном
                  — на своих гостях и{NBSP}качестве их проживания.
                </div>
              </div>
              <div>
                <b>
                  Работая с качественной, лояльной аудиторией, вы формируете базу гостей, которые рекомендуют вас,
                  возвращаются и помогают вашему бизнесу расти.
                </b>
              </div>

              <div>Гости бронируют. На Циан.</div>
            </div>
          </div>
        </div>
      }
    />
  );
};
